import React, { useState } from "react";
import { Typography } from "../../../components/shared/Typography";
import { truncateText } from "../../../utils/textUtils";
import CopyIcon from "../../../components/icons/CopyIcon";
import OpenInNewTabIcon from "../../../components/icons/OpenInNewTabIcon";

interface WalletTagProps {
  address: string;
}

export const WalletTag: React.FC<WalletTagProps> = ({ address }) => {
  const [copied, setCopied] = useState(false);

  // Helper to open address in new tab (e.g., Etherscan)
  const openInNewTab = () => {
    if (!address) return;
    // You can change the explorer URL as needed
    const url = `https://etherscan.io/address/${address}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Helper to copy address to clipboard
  const copyToClipboard = () => {
    if (!address) return;
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(address);
    } else {
      console.error("failed to copy");
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 4000);
  };

  return (
    <div className="flex items-center gap-[2px]">
      {copied && (
        <span
          style={{
            color: "#66db94",
            fontSize: "12px",
            fontWeight: 500,
            minWidth: "40px",
            transition: "color 0.2s",
          }}
        >
          Copied
        </span>
      )}
      <div
        className="flex items-center h-full overflow-hidden"
        style={{
          borderRadius: "4px",
          border: "1px solid #000",
          backgroundColor: "#292930",
          color: "#fff",
        }}
      >
        <Typography className="text-[#DEE0E3] text-[12px] px-[4px]">
          {truncateText(address || "")}
        </Typography>
        <div className="h-full bg-black" style={{ width: "1px" }} />
        <button
          className="flex items-center px-[4px] bg-transparent border-none cursor-pointer transition-colors duration-200 hover:bg-[#4A4C56] focus:outline-none h-full"
          onClick={copyToClipboard}
          type="button"
        >
          <CopyIcon />
        </button>
        <div className="h-full w-px bg-black" />
        <button
          className="flex items-center px-[4px] bg-transparent border-none cursor-pointer transition-colors duration-200 hover:bg-[#4A4C56] focus:outline-none h-full"
          onClick={openInNewTab}
          type="button"
        >
          <OpenInNewTabIcon />
        </button>
      </div>
    </div>
  );
};
